import {
  PATH_SCHOOL,
  PATH_CLASS,
  PATH_DASHBOARD,
  PATH_PARENT,
  PATH_TEACHER,
  PATH_EVENT,
} from '../../../../shared/routes/paths';
import { Iconify } from '../../../../shared/components/base';

export const navConfigAdmin = [
  {
    items: [
      {
        title: 'dashboard',
        path: PATH_DASHBOARD.root,
        icon: <Iconify icon={'eva:grid-outline'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'my school',
        path: PATH_SCHOOL.details,
        icon: <Iconify icon={'eva:home-outline'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'teachers',
        path: PATH_TEACHER.list,
        icon: <Iconify icon={'eva:person-outline'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'classes',
        path: PATH_CLASS.list,
        icon: <Iconify icon={'eva:layers-outline'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'parents',
        path: PATH_PARENT.list,
        icon: <Iconify icon={'eva:people-outline'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'Calendar',
        path: PATH_EVENT.calendar,
        icon: <Iconify icon={'ic:baseline-event'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'messages',
        path: PATH_DASHBOARD.messages,
        icon: <Iconify icon={'ooui:message'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'Hula Lab',
        path: PATH_DASHBOARD.hulaLab,
        icon: <Iconify icon={'raphael:lab'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'lucy',
        path: PATH_DASHBOARD.lucy,
        icon: <Iconify icon={'lucide:bot'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'tutorials',
        path: PATH_DASHBOARD.tutorials,
        icon: <Iconify icon={'mdi:cast-tutorial'} />,
      },
    ],
  },
];

export const navConfigTeachers = [
  {
    items: [
      {
        title: 'dashboard',
        path: PATH_DASHBOARD.root,
        icon: <Iconify icon={'eva:grid-outline'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'my school',
        path: PATH_SCHOOL.details,
        icon: <Iconify icon={'eva:home-outline'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'teachers',
        path: PATH_TEACHER.list,
        icon: <Iconify icon={'eva:person-outline'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'classes',
        path: PATH_CLASS.list,
        icon: <Iconify icon={'eva:layers-outline'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'parents',
        path: PATH_PARENT.list,
        icon: <Iconify icon={'eva:people-outline'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'Calendar',
        path: PATH_EVENT.calendar,
        icon: <Iconify icon={'ic:baseline-event'} />,
      },
    ],
  },

  {
    items: [
      {
        title: 'Hula Lab',
        path: PATH_DASHBOARD.hulaLab,
        icon: <Iconify icon={'raphael:lab'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'lucy',
        path: PATH_DASHBOARD.lucy,
        icon: <Iconify icon={'lucide:bot'} />,
      },
    ],
  },
  {
    items: [
      {
        title: 'tutorials',
        path: PATH_DASHBOARD.tutorials,
        icon: <Iconify icon={'mdi:cast-tutorial'} />,
      },
    ],
  },
];

export const navConfigParents = [
  {
    items: [
      {
        title: 'dashboard',
        path: PATH_DASHBOARD.root,
        icon: <Iconify icon={'eva:grid-outline'} />,
      },
    ],
  },

  {
    items: [
      {
        title: 'Calendar',
        path: PATH_EVENT.calendar,
        icon: <Iconify icon={'ic:baseline-event'} />,
      },
    ],
  },
];
